import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 40,
    fontStyle: 'italic',
    fontFamily: 'Fancy Cut Pro',
    padding: theme.spacing(1.5, 0),
    marginBottom: theme.spacing(6.25),
    lineHeight: '140%',
    letterSpacing: '0.02em',
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(4),
    },
  },
  mobileRoot: {
    textAlign: 'center',
    marginTop: theme.spacing(8),
    lineHeight: 1,
    padding: 0,
  },
}));

const SubpageTitle = ({
  text,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Typography
      className={clsx(classes.root, mobile && classes.mobileRoot)}
      variant="subtitle1"
    >
      {text}
    </Typography>
  );
};

SubpageTitle.propTypes = {
  text: PropTypes.string.isRequired,
};

export default SubpageTitle;
